module.exports = __webpack_public_path__ + "img/italic.4f41c824.svg";